import { Component, Inject, OnDestroy } from "@angular/core";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { PersonDataService } from "../../../core/persons.dataservice";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import * as dataCore from "../../../core/datacore";

@Component({
    selector: "crew-person-edit-workplace",
    template: require('./person.workplace.edit.component.html')
})
export class PersonWorkplaceEditComponent implements OnDestroy {

    private unsubribe: Function;
    FromDate: Date;


    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("person") public person: Nema.Crew.Model.Person,
        @Inject("personWorkplace") public personWorkPlace: Nema.Crew.Model.PersonWorkplace,
        @Inject("workplaces") public workplaces: Nema.Crew.Model.Workplace[],
        private stateService: StateService,
        transitionService: TransitionService,
        private dialog: MatDialog,
        @Inject('$log') private $log: ng.ILogService,
        @Inject("isNew") private isNew: boolean) {

        this.FromDate = dataCore.addTimezoneOffset(this.personWorkPlace.FromDate);

        this.cleanUpSubscription();

        this.unsubribe = transitionService.onBefore({}, transition => {

            var hasChanges = this.personDataService.hasChanges();
            if (hasChanges) {

                let dialogRef = this.dialog.open(ConfirmDialog);

                dialogRef.componentInstance.content = "There are unsaved changes, do you want to continue?";
                dialogRef
                    .afterClosed()
                    .subscribe(res => {
                        if (res) {
                            this.rejectChanges();
                            transition.run();
                        }
                    });

                return false;
            }

            return true;
        });
    }

    public entityDisplayName = "Person Workplaces";

    public listStateName = "app.resources.persons.detail";

    private cleanUpSubscription() {
        if (this.unsubribe) {
            this.unsubribe();
            this.unsubribe = null;
        }
    }

    public ngOnDestroy() {
        this.cleanUpSubscription();
    }

    public save() {

        if (this.isNew) {
            this.personWorkPlace = this.personDataService.newPersonWorkplace(this.person.Id, this.personWorkPlace.WorkplaceId);
        }

        this.personWorkPlace.FromDate = dataCore.subtractTimezoneOffset(this.FromDate);

        this.personDataService
            .save(this.personWorkPlace.Person)
            .then(() => {
                this.$log.info("Successfully saved " + this.entityDisplayName);
                this.backToList();
            })
            .catch(err => this.$log.error("Could not save " + this.entityDisplayName + ", error occured: " + err));
    }

    private rejectChanges() {
        this.personDataService.rejectChanges();
    }

    public cancel() {
        this.rejectChanges();
        this.backToList();
    }

    public backToList(): void {
        this.stateService.go(this.listStateName, { id: this.personWorkPlace.PersonId });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/workplaces/person.workplace.edit.component.ts